import { Controller } from "@hotwired/stimulus"
import { showHubTeamToast } from "../utils/hub_team_toast"

export default class extends Controller {
  static values = { url: String, field: String }

  connect() {
    this.previousValue = this.hiddenInput?.value
    this.reverting = false
    this.boundSave = this.save.bind(this)
    this.element.addEventListener("app-select:change", this.boundSave)
  }

  disconnect() {
    this.element.removeEventListener("app-select:change", this.boundSave)
  }

  async save(event) {
    if (this.reverting) return

    const value = event.detail?.value
    if (!value || !this.hasUrlValue || !this.hasFieldValue || value === this.previousValue) return

    this.setDisabled(true)

    const formData = new FormData()
    formData.append("_method", "PATCH")
    formData.append(`company_user[${this.fieldValue}]`, value)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      if (response.ok) {
        const data = await response.json()
        this.previousValue = data[this.fieldValue]
        this.updateSortData(data[this.fieldValue])
      } else {
        this.revert()
        const message = await this.errorMessage(response)
        showHubTeamToast(`Failed to update ${this.fieldLabel()}: ${message}`, { variant: "error" })
      }
    } catch (error) {
      console.error(`Error updating company user ${this.fieldValue}:`, error)
      this.revert()
      showHubTeamToast("An error occurred. Please try again.", { variant: "error" })
    } finally {
      this.setDisabled(false)
    }
  }

  revert() {
    if (!this.previousValue) return

    const option = this.element.querySelector(
      `[data-app-select-target="option"][data-value="${this.previousValue}"]`
    )
    if (!option) return

    this.reverting = true
    option.click()
    this.reverting = false
  }

  updateSortData(value) {
    const cell = this.element.closest("td")
    if (!cell) return

    cell.dataset.sortValue = value
    cell.dataset.filterValue = value.toLowerCase()
  }

  setDisabled(disabled) {
    const button = this.element.querySelector(".app-select-button")
    if (button) button.disabled = disabled
  }

  fieldLabel() {
    return this.fieldValue.replace(/_/g, " ")
  }

  get hiddenInput() {
    return this.element.querySelector(".select-hidden-input-value")
  }

  async errorMessage(response) {
    try {
      const data = await response.json()
      if (data?.errors?.length) return data.errors.join(", ")
    } catch (_) {
      // fall through
    }
    return `HTTP ${response.status}`
  }
}
